import { MouseEventHandler } from "react";
import { useTranslation } from "@/stores/RootStoreContext";
import { FloatingPortal } from "@floating-ui/react";

export function ShowPreviewButton({ onClick }: { onClick: MouseEventHandler<HTMLButtonElement> }) {
  const { t } = useTranslation();

  return (
    <FloatingPortal>
      <button
        style={{}}
        className={"fixed bottom-0 left-2 shadow-md bg-primary-light px-3 py-2 rounded-t"}
        type="button"
        onClick={onClick}
      >
        {t("show.preview")}
      </button>
    </FloatingPortal>
  );
}
